/**
 * @generated SignedSource<<0a15840bc83cffbb440976ffa226c2de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RepositoryCreateBuildInput = {
  branch: string;
  clientMutationId: string;
  configOverride?: string | null;
  message?: string | null;
  repositoryId: string;
  scriptOverride?: string | null;
  sha?: string | null;
};
export type CreateBuildDialogMutation$variables = {
  input: RepositoryCreateBuildInput;
};
export type CreateBuildDialogMutation$data = {
  readonly createBuild: {
    readonly build: {
      readonly id: string;
    };
  };
};
export type CreateBuildDialogMutation = {
  response: CreateBuildDialogMutation$data;
  variables: CreateBuildDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RepositoryCreateBuildPayload",
    "kind": "LinkedField",
    "name": "createBuild",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateBuildDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateBuildDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "49c03fb73f246778d5e12695bb361716",
    "id": null,
    "metadata": {},
    "name": "CreateBuildDialogMutation",
    "operationKind": "mutation",
    "text": "mutation CreateBuildDialogMutation(\n  $input: RepositoryCreateBuildInput!\n) {\n  createBuild(input: $input) {\n    build {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fb465bfc53d752d4fd660ee475e0111f";

export default node;
